import cloneDeep from 'lodash/cloneDeep';
import { get as getReseau } from '@/api/produit/produitReseauNumerique';
import { get as getEcran } from '@/api/produit/produitNumerique';
import { get as getProduitLocationNum } from '@/api/produit/produitLocation';
import { CATEGORIE_REGROUPEMENT_NUMERIQUE } from '@/configuration/catalogue/produitConf';
import returnLiaisonTarif from '@/services/catalogue/getLiaisonTarifADate';
import genererLiaisonTarifFromProduitAssocie from '@/services/devisCommandes/genererLiaisonTarifFromProduitAssocie';
import updateQuantiteLiaisonTarif from '@/services/devisCommandes/updateQuantiteLiaisonTarif';

async function produitPanierInitializer(panier, typeProduit) {
  const promises = [];
  Object.values(panier).forEach((produitDuPanier) => {
    if (produitDuPanier.produitComplet === undefined) {
      promises.push(typeProduit === CATEGORIE_REGROUPEMENT_NUMERIQUE
        ? getReseau(produitDuPanier.produitId) : getEcran(produitDuPanier.produitId));
    }
  });
  const resultProduit = await Promise.all(promises);
  resultProduit.forEach((produitRecuperer) => {
    panier[produitRecuperer.data.result.id].produitComplet = produitRecuperer.data.result;
  });
}

async function productLocationDictionnaryGetter(panier) {
  const dictionnaireProduitLocation = {};
  let produitId = [];
  Object.values(panier).forEach(produit => {
    produitId = produitId.concat(produit.periode
      .filter(per => {
        return !per.liaisonTarif;
      })
      .map(per => per.produitLocationNum.id));
  });
  produitId = Array.from(new Set(produitId));
  const promises = [];
  produitId.forEach(id => {
    promises.push(getProduitLocationNum(id));
  });
  const result = await Promise.all(promises);
  result.forEach(produitResult => {
    const produit = produitResult.data.result;
    dictionnaireProduitLocation[produit.id] = produit;
  });
  return dictionnaireProduitLocation;
}

export default async function calculTarifDansLePanier(panier, typeProduit) {
  await produitPanierInitializer(panier, typeProduit);
  Object.values(panier).forEach(produit => {
    produit.periode.forEach(p => {
      if (p.prix) {
        return;
      }
      const produitNumerique = produit.produitComplet;
      const liaisonTarifTempo = returnLiaisonTarif(
        produitNumerique, p.produitLocationNum.id, new Date(p.dateDebut),
      );
      p.liaisonTarif = cloneDeep(liaisonTarifTempo);
    });
  });

  const dictionnaireProduitLocation = await productLocationDictionnaryGetter(panier);
  Object.values(panier).forEach(produit => {
    produit.periode.forEach(p => {
      if (!p.liaisonTarif) {
        const produitLocationNumAssocie = dictionnaireProduitLocation[p.produitLocationNum.id];
        const liaisonTarifTempo = genererLiaisonTarifFromProduitAssocie(
          produitLocationNumAssocie, p,
        );
        p.liaisonTarif = cloneDeep(liaisonTarifTempo);
      }
      if (p.liaisonTarif.prixUnitaire && p.liaisonTarif.quantite) {
        updateQuantiteLiaisonTarif(p.liaisonTarif, p.dateDebut, p.dateFin);
        if (p.liaisonTarif.quantiteAjustee) {
          p.prix = p.liaisonTarif.prixUnitaire * p.liaisonTarif.quantiteAjustee;
        } else {
          p.prix = p.liaisonTarif.prixUnitaire * p.liaisonTarif.quantite;
        }
      }
    });
  });
  return panier;
}
